"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportMessage = exports.reportWarning = exports.reportError = exports.WIX_SDK_MESSAGE_TEXT = exports.WIX_SDK_WARNING_TEXT = exports.WIX_SDK_ERROR_TEXT = void 0;
exports.WIX_SDK_ERROR_TEXT = 'Wix code SDK error:';
exports.WIX_SDK_WARNING_TEXT = 'Wix code SDK warning:';
exports.WIX_SDK_MESSAGE_TEXT = 'Wix code SDK message:';
const reportError = (message) => {
    console.error(`${exports.WIX_SDK_ERROR_TEXT} ${message}`);
};
exports.reportError = reportError;
const reportWarning = (message) => {
    console.warn(`${exports.WIX_SDK_WARNING_TEXT} ${message}`);
};
exports.reportWarning = reportWarning;
const reportMessage = (message) => {
    console.log(`${exports.WIX_SDK_MESSAGE_TEXT} ${message}`);
};
exports.reportMessage = reportMessage;
//# sourceMappingURL=reporters.js.map